import {selectAllNodes, selectNode} from './helpers';
import {addToCart} from './cart';

// Remove items from cart on cart page and in the header
export function removeFromCart (btn, totalNode) {
  return (e) => {
    e.preventDefault();
    const countNodes = selectAllNodes('wa-cart-link-counter');
    const key = btn.dataset.key;
    const productItem = btn.parentNode;
  
    btn.classList.add('preload');
  
    return jQuery.ajax({
      url: window.sharedResources.ajaxurl,
      type: 'POST',
      data: {
        action: 'remove-from-cart',
        key: key
      } 
    })
    .done((data) => {
      if (data) {
        const modifyTotals = data => node => node.innerHTML = data; 
  
        if (countNodes) countNodes.map(modifyTotals(data.count));
        if (totalNode) modifyTotals(data.total)(totalNode);
  
        productItem.classList.add('hidden');
        window.setTimeout(() => productItem.classList.add('removed'), 300);
        if (document.body.classList.contains('woocommerce-checkout')) document.location.reload();
      }
    });
  };
}

export function addToHeaderCart (addedData) {
  if (!addedData.items_count) return;
  const productsCount = selectAllNodes('wa-cart-link-counter');
  const productsContainer = selectNode('wa-cart-items');
  const productsTotal = selectNode('total-price-amount');

  productsCount.map(counter => counter.innerHTML = addedData.items_count);
  productsTotal.innerHTML = addedData.cart_total;
  productsContainer.innerHTML = addedData.product_items;

  //Add event listeners to newly created cart items
  const removeBtn = selectAllNodes('wa-cart-item__remove', productsContainer);

  removeBtn.map(btn => btn.addEventListener('click', removeFromCart(btn, productsTotal)));
}

function getSmallCartData () {
  const smallCartInputs = selectAllNodes('wa-cart-item__input');
  return smallCartInputs.reduce((obj, input) => {
    return [...obj, {id: input.dataset.id, key: input.dataset.key, qty: input.value}];
  }, []);
}

function openCart (link) {
  const cart = selectNode('wa-cart');
  const cartSubmit = selectNode('wa-cart-checkout', cart);
  if (cart.classList.contains('opened')) {
    cart.classList.remove('opened');
    return;
  } else {

    const linkHeight = link.clientHeight;
    const rect = link.getBoundingClientRect();
    const top = rect.top;
    const left = rect.left;
  
    cart.style.left = `${left}px`; 
    cart.style.top = `${top + linkHeight + 10}px`;
    cart.classList.add('opened');
    cartSubmit.focus();
  }
}

export default function smallCartFunctionality () {
  const cart = selectNode('wa-cart');
  const cartBtn = selectAllNodes('wa-cart-link');
  const preloaders = selectAllNodes('wa-cart-link-preloader');
  const removeBtn = selectAllNodes('wa-cart-item__remove');
  const productsTotal = selectNode('total-price-amount');
  const checkoutBtns = selectAllNodes('wa-cart-checkout');

  // console.dir(preloaders);
  removeBtn.map(btn => btn.addEventListener('click', removeFromCart(btn, productsTotal)));

  cartBtn.map(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart(btn);
    });
  });

  // submit changes and redirect to cart page
  const submitSmallCart = (e) => {
    addToCart(getSmallCartData(), true);
    document.addEventListener('product-submited', () => {
      window.location.href = e.target.dataset.carturl;
    });
  };

  checkoutBtns.map(btn => btn.addEventListener('click', submitSmallCart));

  const hideCart = () => {
    if (cart.classList.contains('opened')) cart.classList.remove('opened');
  };

  const showPreloader = () => {
    preloaders.map(el => el.classList.add('preload'));
  };
  const hidePreloader = () => {
    preloaders.map(el => el.classList.remove('preload'));
  };

  // // check for touch device
  // const is_touch_device = () => 'ontouchstart' in window || navigator.maxTouchPoints;

  // if (is_touch_device()) {
  // } else {
  //   document.addEventListener('scroll', hideCart, {passive: true});
  // }
  selectNode('site-content').addEventListener('click', hideCart);

  //cart preloader functionality
  document.addEventListener('submit-started', showPreloader);
  document.addEventListener('product-submited', hidePreloader);
}